<template>
  <div>
    <admin-title-bar :title-stack="titleStack"/>
    <admin-main-section>
      <admin-card-component
          title="Details :"
          :status="formOrder.transaction"
          hasTable

      >
        <div class="px-28">
          <div v-if="formOrder != null" class="bg-blueLightNat text-white p-5">
            <div class="font-bold"> Billing Address :</div>
            <div> First name : {{formOrder.first_name}}</div>
            <div> Last name : {{formOrder.last_name}}</div>
            <div> Address : {{ formOrder.address }}, {{ formOrder.city }}, {{ formOrder.state }}, {{ formOrder.zip_code }}, {{ formOrder.country }}</div>
            <div> Phone Number : {{formOrder.phone_number}}</div>
            <div> Email Address : {{formOrder.email_address}}</div>
          </div>
          <div v-if="formShipping != null" class="bg-blueLightNat text-white p-5">
            <div class="font-bold"> Shipping Address :</div>
            <div> First name : {{ formShipping.first_name }}</div>
            <div> Last name : {{ formShipping.last_name }}</div>
            <div> Address : {{ formShipping.address }}, {{ formShipping.city }}, {{ formShipping.state }},
              {{ formShipping.zip_code }}, {{ formShipping.country }}
            </div>
          </div>
        </div>
        <admin-divider/>
        <table >
          <thead >
          <tr >
            <th class="font-medium">Id
            </th>
            <th class="font-medium">
              Category
            </th>
            <th class="font-medium">
              Product Name
            </th >
            <th class="font-medium">
              Option Name
            </th>
            <th class="font-medium">
              Option Category
            </th>
            <th class="font-medium">
              Thumbnail
            </th>
            <th class="font-medium">
              Quantity
            </th>
            <th class="font-medium">
              Price
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(item, index) in products"
              :key="item.id"
              :class="[tableTrStyle, index % 2 === 0 ? tableTrOddStyle : '']"
              class="align-top"
          >
            <td>
              {{ item.id }}
            </td>
            <td>
              <div v-if="item.hasOwnProperty('offers')">
                <p> {{ item.category }} </p>
                <p v-for="(offer,i) in item.offers"> - {{ offer.category }} </p>
              </div>
              <p v-else> {{ item.category }} </p>
            </td>
            <td>
              <div v-if="item.hasOwnProperty('offers')" class="font-bold">
                <p class="font-bold"> {{ item.name }}: </p>
                <p class="font-bold" v-for="(offer,i) in item.offers"> - {{ offer.name }} </p>
              </div>
             <p v-else> {{ item.name }} </p>
            </td>
            <td>
              <div v-if="item.hasOwnProperty('offers')">
                <p> {{ item.option }} </p>
                <p v-for="(offer,i) in item.offers"> {{ offer.option }} </p>
              </div>
              <p v-else> {{ item.option }} </p>
            </td>
            <td>
              <div v-if="item.hasOwnProperty('offers')">
                <p v-if=" item.category_option"> {{ item.category_option }} </p>
                <br v-else>
                <p v-for="(offer,i) in item.offers"> - {{ offer.category_option }} </p>
              </div>
              <p v-else> {{ item.category_option }} </p>
            </td>
            <td>
              <img v-if="item.thumbnail != null" class="w-32" :src="usePhoto(item.thumbnail)"  :alt="item.name"/>
            </td>
            <td>
              <div v-if="item.hasOwnProperty('offers')">
                <p> {{ item.quantity }} </p>
                <p v-for="(offer,i) in item.offers"> {{ offer.quantity }} </p>
              </div>
              <p v-else> {{ item.quantity }} </p>
            </td>
            <td>
              $ {{ item.price }}
            </td>
          </tr>
          <tr>
            <th>
            </th>
            <th>
            </th>
            <th>
            </th>
            <th>
            </th>
            <th>
            </th>
            <th>
            </th>
            <th>
              <div>Subtotal :</div>
              <div v-if="formOrder.discount !== 0">Promo Discount :</div>
              <div v-if="formOrder.campaign_id > 0">Promo Code :</div>
              <div>Surcharge :</div>
              <div>Tax :</div>
              <div>Shipping :</div>
              <div>Total :</div>
            </th>
            <th>
              <div>$ {{parseFloat(formOrder.subtotal).toFixed(2)}}</div>
              <div v-if="formOrder.discount > 0">$ {{parseFloat(formOrder.discount).toFixed(2)}}</div>
              <div v-if="formOrder.campaign_id > 0"> {{formOrder.voucher_name}}</div>
              <div>$ {{parseFloat(formOrder.surcharge_amount).toFixed(2)}} ({{formOrder.surcharge}} %)</div>
              <div>$ {{parseFloat((formOrder.subtotal - formOrder.discount)*formOrder.tax/100).toFixed(2)}} ({{formOrder.tax}} %)</div>
              <div>$ {{parseFloat(formOrder.shipping_tax).toFixed(2)}}</div>
              <div>$ {{parseFloat(formOrder.total).toFixed(2)}}</div>
            </th>
          </tr>
          </tbody>
        </table>
        <admin-divider/>
        <div  class="flex flex-row justify-between">
        <div  class="pl-4 pb-3">
          <div class="w-fit">Transaction ID : {{formOrder.transaction_id}}</div>
          <div class="w-fit">Date : {{new Intl.DateTimeFormat('default').format(new Date(formOrder.created_at))}}</div>
        </div>
        <div class="w-fit items-end pr-4">
          <admin-jb-button
              v-if="userRoles.includes('Superadmin')" @click="showOrderLogs"
              color="danger"
              label="Show Logs (look in the request)"
          />
        </div>
        </div>
      </admin-card-component>
    </admin-main-section>
  </div>
</template>

<script setup>
import {mdiCart} from '@mdi/js'
import {http} from "~/utils/http";
import {UserShippingAddresses, OrderInfo} from "~/composables/nhTypes";
import {computed, ref} from "vue";
import {useMainStore} from '@/stores/main'
import {usePhoto} from "~/composables";

definePageMeta({
  layout: "admin",
});

const titleStack = ref(['Admin / Orders', 'Order Products']);

const route = useRoute();
const id = route.params.id;
const formShipping = ref(new UserShippingAddresses());
const formOrder = ref(new OrderInfo());
const errors = ref([]);
const success = ref('');
const mainStore = useMainStore()
const products = ref([]);
const orderLogs = ref(null);
const userRoles = computed(() => mainStore.userRoles)

const tableTrStyle = computed(() => mainStore.tableTrStyle)

const tableTrOddStyle = computed(() => mainStore.tableTrOddStyle)

const getData = async () => {
  try {
    await http
        .get("/api/orders/" + id)
        .then((response) => {
          products.value = response.data.products;
          formShipping.value = response.data.shippingAddress;
          formOrder.value = response.data.orderInformation;
          formOrder.value.campaign_id = formOrder.value.campaign ? formOrder.value.campaign.id : 0;
          formOrder.value.voucher_name = formOrder.value.campaign ? formOrder.value.campaign.voucher_name : '';
          formOrder.value.discount = 0;
          if(formOrder.value.campaign){
            let discount = formOrder.value.campaign.discount;
            if(formOrder.value.campaign.campaign_offers.length > 0){
              formOrder.value.products.forEach(product =>{
                let item = formOrder.value.campaign.campaign_offers.find(el => el.offer_id === product.product_id);
                if(item !== undefined){
                  if(formOrder.value.campaign.discount_type === 0){
                    formOrder.value.discount += formOrder.value.campaign.discount/100 * product.price * product.quantity;
                  }else if(formOrder.value.campaign.discount_type === 1 && discount > 0){
                    if(product.price * product.quantity < discount){
                      formOrder.value.discount += product.price * product.quantity;
                      discount -= product.price * product.quantity;
                    }else {
                      formOrder.value.discount += discount;
                      discount = 0;
                    }
                  }
                }
              })
            }else{
              let discount = formOrder.value.campaign.discount;
              formOrder.value.products.forEach(product =>{
                if(formOrder.value.campaign.discount_type === 0){
                  formOrder.value.discount += formOrder.value.campaign.discount/100 * product.price * product.quantity;
                }else if(formOrder.value.campaign.discount_type === 1 && discount > 0){
                  if(product.price * product.quantity < discount){
                    formOrder.value.discount += product.price * product.quantity;
                    discount -= product.price * product.quantity;
                  }else {
                    formOrder.value.discount += discount;
                    discount = 0;
                  }
                }
              })
            }
          }

        });
  } catch (e) {
    console.log(e);
  }
};

const showOrderLogs = async () => {
  try {
    await http
        .get("/api/order-logs/" + id)
        .then((response) => {
          orderLogs.value = response.data;
     });
  } catch (e) {
    console.log(e);
  }
};

const onInvalidSubmit = async () => {

}
const start = async () => {
  mainStore.setOverlay(true);
  await getData();
  mainStore.setOverlay(false);
}

start();
</script>
